import { AVAILABLE_CLIENTS as c } from "@scalar/snippetz";
const d = "shell/curl", u = (o) => c.includes(o), e = (o, r) => {
  var f;
  const n = (f = o[0]) == null ? void 0 : f.options[0];
  if (r)
    for (const i of o) {
      const t = i.options.find((s) => s.id === r);
      if (t)
        return t;
    }
  if (!(n != null && n.id.startsWith("custom")))
    for (const i of o) {
      const t = i.options.find((s) => s.id === d);
      if (t)
        return t;
    }
  return n;
};
export {
  d as DEFAULT_CLIENT,
  e as findClient,
  u as isClient
};
